import { DashboardTimeFrame } from 'containers/dashboard/types/types';

export const defaultActiveProjectDashboardCardTimeFrame: DashboardTimeFrame = 'pastFourteen';
